"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var constants_1 = __importDefault(require("../../../config/constants"));
var AccessibleDisabledButton_1 = __importDefault(require("../../../shared/components/button/AccessibleDisabledButton"));
var PasswordStrengthIndicator_1 = __importDefault(require("../../../shared/components/password/PasswordStrengthIndicator"));
var validations_1 = require("../validations");
var styles_1 = __importDefault(require("./styles"));
var PasswordResetForm = function (_a) {
    var onSubmit = _a.onSubmit, title = _a.title, description = _a.description, disableAutofill = _a.disableAutofill;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(''), password = _b[0], setPassword = _b[1];
    var _c = (0, react_1.useState)(''), confirmPassword = _c[0], setConfirmPassword = _c[1];
    var handlePasswordChange = function (value) {
        setPassword(value);
    };
    var handleConfirmPasswordChange = function (value) {
        setConfirmPassword(value);
    };
    var canSubmit = function () {
        onSubmit(password);
    };
    var passwordErrors = validations_1.passwordValidatorSchema.validate(password, {
        list: true
    });
    var activeButton = typeof passwordErrors !== 'boolean' &&
        passwordErrors &&
        passwordErrors.length === 0 &&
        password === confirmPassword;
    var passwordField = {
        type: 'password',
        key: 'password',
        label: t('login.password'),
        get placeholder() {
            return t('login.password');
        },
        value: password,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return password;
        },
        validationSchema: validations_1.passwordValidation,
        disabledAutofill: disableAutofill
    };
    var confirmPasswordField = {
        type: 'password',
        key: 'confirmPassword',
        label: t('resetPassword.confirmPassword'),
        get placeholder() {
            return t('resetPassword.confirmPassword');
        },
        value: confirmPassword,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return confirmPassword;
        },
        validationSchema: validations_1.confirmPasswordValidation,
        disabledAutofill: disableAutofill
    };
    return (react_1.default.createElement(core_1.Grid, { sm: 10, md: 10 },
        react_1.default.createElement(core_1.Typography, { component: "h1", variant: "h2", className: classes.titleText }, t('resetPassword.title')),
        !!title && (react_1.default.createElement(core_1.Typography, { color: "primary", variant: "h1", className: classes.titleText }, title)),
        react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1" }, !!description ? description : t('resetPassword.description')),
        react_1.default.createElement(package_1.FieldRenderer, { field: passwordField, onChange: handlePasswordChange, className: classes.field, inputProps: {
                role: 'textbox',
                'aria-label': t('login.password'),
                fullWidth: true,
                variant: constants_1.default.FIELDS_VARIANT
            } }),
        react_1.default.createElement(PasswordStrengthIndicator_1.default, { password: password, passwordErrors: passwordErrors }),
        react_1.default.createElement(package_1.FieldRenderer, { field: confirmPasswordField, onChange: handleConfirmPasswordChange, className: classes.field, inputProps: {
                role: 'textbox',
                'aria-label': t('resetPassword.confirmPassword'),
                fullWidth: true,
                variant: constants_1.default.FIELDS_VARIANT
            } }),
        react_1.default.createElement(AccessibleDisabledButton_1.default, { size: "large", variant: "contained", color: "primary", fullWidth: true, "aria-label": "Save", onClick: canSubmit, disabled: !activeButton, className: classes.button }, t('save'))));
};
exports.default = PasswordResetForm;
//# sourceMappingURL=PasswordResetForm.js.map